import * as React from "react";
// import { cn } from "../../utility/utils";
import { Controller } from "react-hook-form";

const Input = React.forwardRef(
  (
    { className, type, label, control, rules, name, onChangeFn, ...props },
    ref
  ) => {
    // Prevent scroll wheel from changing number input values
    const handleWheel = React.useCallback(
      (e) => {
        if (type === "number") {
          // Prevent the input value from changing
          e.target.blur();
        }
      },
      [type]
    );

    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <div className="flex flex-col space-y-2">
              <label>
                {label}
                {rules?.required && <span className=" text-red-600">*</span>}
              </label>
              <input
                type={type}
                className={"input-field"}
                ref={ref}
                value={value}
                onChange={(e) => {
                  onChange(e);
                  onChangeFn?.(e);
                }}
                onWheel={handleWheel}
                {...props}
              />
              {error && (
                <small className="text-red-600 font-medium text-sm error-text">
                  {error.message}
                </small>
              )}
            </div>
          </>
        )}
      />
    );
  }
);
Input.displayName = "Input";

export default Input;
